import { Button, Text } from "@radix-ui/themes";
import { PlusIcon } from "@radix-ui/react-icons";

export interface EditableTableEmptyStateProps {
  emptyStateText: string;
  addButtonText: string;
  onAddRow: () => void;
}

export function EditableTableEmptyState({
  emptyStateText,
  addButtonText,
  onAddRow,
}: EditableTableEmptyStateProps) {
  return (
    <div className="flex flex-col gap-2 text-center py-8 text-gray-9">
      <Text size="3" highContrast weight="medium">
        {emptyStateText}
      </Text>
      <div>
        <Button size="2" variant="soft" color="gray" onClick={onAddRow}>
          <PlusIcon />
          {addButtonText}
        </Button>
      </div>
    </div>
  );
}
